import React, { useEffect, useRef, useState } from 'react'

import Layout from 'components/Layout'
import EmptyLogo from 'images/ChainXY_Map.png'

const ChainXy_Fleet = () => {
	return (
		<Layout>
			<Layout.Page>
				<Layout.Body>
					<div>
						<div>
							<img src={EmptyLogo} alt="" />
						</div>
					</div>
				</Layout.Body>
			</Layout.Page>
		</Layout>
	)
}

export default ChainXy_Fleet
